import { Box, useTheme } from '@mui/material';
import { gptContainerSx } from './GPT.style';
import Typewriter from 'typewriter-effect';

export const GPT = ({ height, typeString, callback = () => {} }) => {
  const theme = useTheme();

  return (
    <Box component="div" sx={gptContainerSx(theme, height)}>
      <Typewriter
        onInit={(typewriter) => {
          typewriter
            .changeDelay(15)
            .typeString(typeString)
            .callFunction(callback)
            .start();
        }}
      />
    </Box>
  );
};
